export default {
  list: [
    {
      value: 'SALON',
      title: 'داخل سالن'
    },
    {
      value: 'OUTDOOR',
      title: 'فضای باز'
    },
    {
      value: 'ROOM',
      title: 'اتاق'
    }
  ],
  values: {
    SALON: 'SALON',
    OUTDOOR: 'OUTDOOR',
    ROOM: 'ROOM'
  }
};
